<template>
  <div class="templates">
    <el-container>
      <el-header>
        <div class="logo hidden-xs-only">
          <img height="100%" src="../assets/logo_nav.png" />
        </div>
        <div class="hidden-xs-only nav-top">
          <div style="width:56px;"></div>
          <div class="title hidden-xs-only"><h3>模板市场</h3></div>
          <el-button
            round
            size="mini"
            type="primary"
            @click="$router.push({ path: '/' })"
            style="background-color:rgba(0, 0, 0, 0.25);border-color:transparent;"
          >
            登录
          </el-button>
        </div>
        <div class="logo hidden-sm-and-up">
          <img height="80%" src="../assets/logo_nav.png" />
        </div>
        <div class="title hidden-sm-and-up" style="text-align:right;padding-right:1rem;">
          <h4>模板市场</h4>
        </div>
      </el-header>
      <el-container class="c-container">
        <el-aside class="hidden-xs-only">
          <div class="home-search">
            <i class="el-icon-s-home c_pointer" @click="home"></i>
            <el-input
              placeholder="搜索模板"
              prefix-icon="el-icon-search"
              v-model="search.query"
              @input="
                formData = {};
                getData();
              "
              clearable
            ></el-input>
          </div>
          <el-menu
            class="el-menu-vertical-demo"
            text-color="rgba(43,52,65,.6)"
            active-text-color="#333"
            default-active="recommend"
            @select="handleSelect"
          >
            <el-menu-item index="recommend">
              <span slot="title">全部模板</span>
            </el-menu-item>
            <el-menu-item-group>
              <template slot="title">
                场景模板
              </template>
              <el-menu-item
                :index="'scene-' + item.value"
                v-for="(item, i) in options.scene"
                :key="i"
              >
                <span slot="title">{{ item.label }}</span>
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <template slot="title">
                行业模板
              </template>
              <el-menu-item
                :index="'trade-' + item.value"
                v-for="(item, i) in options.trade"
                :key="i"
              >
                <span slot="title">{{ item.label }}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main>
            <div>
              <div
                class="nav hidden-sm-and-up"
                :style="
                  search.key == 'scene' || search.key == 'trade' || search.query || formData._id
                    ? 'margin-bottom: 1rem;'
                    : ''
                "
              >
                <i class="el-icon-s-home" @click="home"></i>
                <el-input
                  class="nav-search"
                  placeholder="搜索模板"
                  prefix-icon="el-icon-search"
                  v-model="search.query"
                  @input="
                    formData = {};
                    getData();
                  "
                  clearable
                ></el-input>
                <el-dropdown trigger="click" @command="handleSelect">
                  <el-button>
                    分类
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="recommend">
                      全部模板
                    </el-dropdown-item>
                    <el-dropdown-item disabled divided>
                      场景模板
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-for="(item, i) in options.scene"
                      :key="'scene-' + i"
                      :command="'scene-' + item.value"
                    >
                      {{ item.label }}
                    </el-dropdown-item>
                    <el-dropdown-item disabled divided>
                      行业模板
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-for="(item, i) in options.trade"
                      :key="'trade-' + i"
                      :command="'trade-' + item.value"
                    >
                      {{ item.label }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <template v-if="!formData._id">
                <div
                  class="cards recommended"
                  v-if="search.key != 'scene' && search.key != 'trade' && !search.query"
                >
                  <el-row :gutter="20">
                    <template v-for="(item, i) in fpi.list">
                      <el-col
                        :key="i"
                        v-if="i < 3"
                        :lg="8"
                        :md="12"
                        :sm="12"
                        :xs="24"
                        :class="
                          i == 0 || i == 1 ? 'hidden-xs-only' : i == 2 ? 'hidden-md-and-down' : ''
                        "
                      >
                        <div
                          class="card"
                          :style="`background-color:${item.exts.bgcolor}`"
                          @click="doClick(item)"
                        >
                          <div
                            class="card-item"
                            :style="`background: url(${item.exts.banner}) center center / cover;`"
                          ></div>
                          <h1>{{ item.exts.title }}</h1>
                        </div>
                      </el-col>
                    </template>
                  </el-row>
                  <el-row :gutter="20" class="el-row-sec">
                    <template v-for="(item, i) in fpi.list">
                      <el-col
                        :lg="6"
                        :md="8"
                        :sm="8"
                        :xs="24"
                        :key="i"
                        :class="
                          i == 0 || i == 1
                            ? 'hidden-sm-and-up'
                            : i == 2
                            ? 'hidden-lg-and-up'
                            : i > 4 && i <= 7
                            ? 'hidden-xs-only'
                            : i > 7 && i <= 10
                            ? 'hidden-md-and-down'
                            : i > 10
                            ? 'hidden-lg-and-down hidden-lg-and-up'
                            : ''
                        "
                      >
                        <div
                          class="card"
                          :style="`background-color:${item.exts.bgcolor}`"
                          @click="doClick(item)"
                        >
                          <div
                            class="card-item"
                            :style="`background: url(${item.exts.banner}) center center / cover;`"
                          ></div>
                          <h1>{{ item.exts.title }}</h1>
                        </div>
                      </el-col>
                    </template>
                  </el-row>
                </div>
                <div class="cards all">
                  <div class="title" v-if="fpi.data || fpi.list">
                    <h4>{{ typeName }}</h4>
                  </div>
                  <el-row :gutter="20">
                    <template v-for="(item, i) in fpi.data">
                      <el-col :key="i" :lg="8" :md="8" :sm="12" :xs="24">
                        <div class="item" @click="doClick(item)">
                          <div
                            class="img"
                            :style="`background: url(${item.exts.banner}) center center / cover;`"
                          ></div>
                          <div class="info">
                            <h4>{{ item.exts.title }}</h4>
                            <div class="content">
                              {{ item.exts.desc }}
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </template>
                  </el-row>
                </div>
              </template>
              <div v-if="formData._id" class="form">
                <div
                  class="banner"
                  :style="`background: url(${formData.exts.banner}) center center / cover;`"
                ></div>
                <div class="title">
                  <h2>{{ formData.exts.title }}</h2>
                  <el-button type="primary" class="hidden-xs-only" @click="openRegister">
                    立即体验
                  </el-button>
                </div>
                <div class="tags">
                  <span class="tag" v-for="(item, i) in formData.scene" :key="'scene' + i">
                    {{ formatScene(item) }}
                  </span>
                  <span class="tag" v-for="(item, i) in formData.trade" :key="'trade' + i">
                    {{ formatTrade(item) }}
                  </span>
                </div>
                <div class="desc">
                  {{ formData.exts.desc }}
                </div>
                <el-button
                  type="primary"
                  class="hidden-sm-and-up"
                  style="height:45px;margin-bottom:1rem;font-size:16px;"
                  @click="openRegister"
                >
                  立即体验
                </el-button>
                <div class="content" v-html="formData.exts.content"></div>
              </div>
              <el-dialog
                class="register-dialog"
                title="创建账号并体验"
                :visible.sync="registerShow"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
              >
                <el-form :model="register" ref="register">
                  <el-form-item
                    label="公司名称"
                    prop="name"
                    :rules="[
                      {
                        required: true,
                        message: '请输入您的公司名称',
                        trigger: 'blur'
                      }
                    ]"
                  >
                    <el-input placeholder="请输入您的公司名称" v-model="register.name"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="手机号"
                    prop="phone"
                    :rules="[
                      {
                        required: true,
                        pattern: /^(1[3-9]{1}\d{9}|0\d{2,3}\d{7,8}|400[0-9]{7}|800[0-9]{7})$/,
                        message: '请输入正确格式的手机号',
                        trigger: 'blur'
                      }
                    ]"
                  >
                    <el-input
                      placeholder="请输入手机号，将作为登录账号"
                      v-model="register.phone"
                      :maxlength="11"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="验证码"
                    prop="exts.verifyCode"
                    :rules="[
                      {
                        required: true,
                        pattern: /^\d{6}$/,
                        message: '请输入6位数字验证码',
                        trigger: 'blur'
                      }
                    ]"
                  >
                    <el-input
                      placeholder="请输入验证码"
                      v-model="register.exts.verifyCode"
                      :maxlength="6"
                    >
                      <template slot="append" v-if="sent">
                        重新获取({{ count }})
                      </template>
                      <template slot="append" v-else>
                        <span @click="sendCode">发送验证码</span>
                      </template>
                    </el-input>
                  </el-form-item>
                  <!-- <el-form-item
                    label="邮箱"
                    prop="email"
                    :rules="[
                      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                      {
                        type: 'email',
                        message: '请输入正确的邮箱地址',
                        trigger: ['blur', 'change']
                      }
                    ]"
                  >
                    <el-input placeholder="请输入邮箱" v-model="register.email"></el-input>
                  </el-form-item> -->
                  <el-form-item
                    label="密码"
                    prop="exts.password"
                    :rules="[
                      {
                        required: true,
                        pattern: /^[a-z0-9]{6,18}$/,
                        message: '请输入6-18位密码，只允许包含字母、数字',
                        trigger: 'blur'
                      }
                    ]"
                  >
                    <el-input
                      placeholder="请输入密码，将作为登录密码"
                      v-model="register.exts.password"
                      show-password
                      autocomplete="new-password"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="地址" prop="address">
                    <el-input placeholder="请输入地址" v-model="register.address"></el-input>
                  </el-form-item>
                  <el-form-item class="submit">
                    <el-button type="primary" @click="doSave">提交</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </div>
          </el-main>
          <!-- <el-footer></el-footer> -->
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      params: {}, //url参数
      search: {}, //模板过滤
      // 模板分类
      typeName: '全部模板',
      options: {
        codecfg_trade: { codeId: 'trade' },
        codecfg_scene: { codeId: 'scene' }
      },
      // 模板列表
      fpi: {},
      // 模板详情
      formData: {},
      // 注册租户
      registerShow: false,
      register: { exts: {} },
      // 手机验证码
      sent: false,
      count: 60
    };
  },
  beforeMount() {
    window.$this = this;
  },
  mounted() {
    this.params = this.$route.query;
    this.osg.codeoption(
      () => {
        this.$forceUpdate();
        if (this.params.tid) {
          this.getTemplate(this.params.tid);
        } else {
          this.getData();
        }
      },
      null,
      null,
      '0'
    );
  },
  methods: {
    home() {
      let params = this.$util.deepCopy(this.params);
      delete params.tid; // 如果有模板id则去掉
      this.$router.push({ path: '/Templates', query: params });
      this.$router.go(0);
    },
    handleSelect(index) {
      this.formData = {};
      if (index.indexOf('-') != -1) {
        this.search.key = index.split('-')[0];
        this.search.val = index.split('-')[1];
        // 百度事件统计
        if (window._hmt) {
          window._hmt.push([
            '_trackEvent',
            'template',
            'click',
            this.osg.codelabel(this.search.key, this.search.val)
          ]);
        }
      } else {
        this.search.key = '';
        this.search.val = '';
      }
      this.formatType();
      this.getData();

      // 修改url
      let params = this.$util.deepCopy(this.params);
      delete params.tid;
      this.$router.replace({
        path: '/Templates',
        query: params
      });
    },
    formatType() {
      if (this.search.key) {
        for (let item of this.options[this.search.key]) {
          if (item.value == this.search.val) {
            this.typeName = item.label;
            return;
          }
        }
      } else {
        this.typeName = '全部模板';
      }
    },
    getData() {
      let params = {
        _all: '1',
        'is:exts.isTemplate|string#and': '1',
        'regex:exts.title|string#and': this.search.query,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // 场景、行业过滤
      if (this.search.key == 'scene') {
        params['in:scene|array#and'] = this.search.val;
      } else if (this.search.key == 'trade') {
        params['in:trade|array#and'] = this.search.val;
      }
      this.osg.ajax(
        'i/templateMarket/findBaseTemplateMarket.do',
        params,
        res => {
          let clientWidth = document.body.clientWidth;
          res.data.map(item => {
            // 默认banner
            if (this.$util.isJson(item.exts.banner) && JSON.parse(item.exts.banner).length > 0) {
              item.exts.banner = JSON.parse(item.exts.banner)[0].url;
            }
            if (item.exts.content) {
              // 移动端模板内容图片单列展示
              if (clientWidth <= 768) {
                item.exts.content = item.exts.content.replace(
                  /<img /g,
                  '<img style="max-width:100%;border:1px solid #f2f2f2;" '
                );
              } else {
                item.exts.content = item.exts.content.replace(
                  /<img /g,
                  '<img style="max-width:48%;border:1px solid #f2f2f2;margin:0 1%;box-sizing:border-box;" '
                );
              }
            }
          });
          res.list = res.data.filter(item => {
            return item.exts.isRecommend == '1';
          });
          this.fpi = res;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    getTemplate(tid) {
      this.osg.ajax(
        'i/templateMarket/findById.do',
        { id: tid },
        res => {
          if (
            this.$util.isJson(res.data.exts.banner) &&
            JSON.parse(res.data.exts.banner).length > 0
          ) {
            res.data.exts.banner = JSON.parse(res.data.exts.banner)[0].url;
          }
          if (res.data.exts.content) {
            let clientWidth = document.body.clientWidth;
            // 移动端模板内容图片单列展示
            if (clientWidth <= 768) {
              res.data.exts.content = res.data.exts.content.replace(
                /<img /g,
                '<img style="max-width:100%;border:1px solid #f2f2f2;" '
              );
            } else {
              res.data.exts.content = res.data.exts.content.replace(
                /<img /g,
                '<img style="max-width:48%;border:1px solid #f2f2f2;margin:0 1%;box-sizing:border-box;" '
              );
            }
          }
          this.formData = res.data;
        },
        {
          noload: true
        }
      );
    },
    doClick(item) {
      this.formData = item;
      let params = this.$util.deepCopy(this.params);
      this.$router.replace({
        path: '/Templates',
        query: Object.assign(params, { tid: item._id })
      });
      this.$forceUpdate();
    },
    openRegister() {
      this.registerShow = true;
      this.$nextTick(() => {
        if (this.$refs.register) this.$refs.register.clearValidate();
      });
    },
    sendCode() {
      if (/^(1[3-9]{1}\d{9}|0\d{2,3}\d{7,8}|400[0-9]{7}|800[0-9]{7})$/.test(this.register.phone)) {
        let timestamp = new Date().getTime();
        let phone = this.register.phone;
        this.osg.ajax(
          '/i/templateMarket/sendVerifyCode.do',
          { timestamp, phone, m: window.md5('xlink*api*md5' + timestamp + phone) },
          () => {
            // 验证码已发送-倒计时60s
            this.sent = true;
            this.count = 60;
            var timer = setInterval(() => {
              --this.count;
              if (this.count <= 0) {
                clearInterval(timer);
                this.sent = false;
              }
            }, 1000);
          },
          {
            noload: true
          }
        );
      } else {
        this.osg.toast('请输入正确格式的手机号', 'warning');
      }
    },
    doSave() {
      if (this.osg.validate('register')) {
        this.register.code = this.register.phone;
        this.register.email = this.register.phone + '@fs-go.cn';
        this.register.level = '1';
        this.register.roles = ['2'];
        if (this.params.aid) this.register.agencyId = this.params.aid; //运营商id
        this.osg.ajax(
          // `i/templateMarket/applyTemplateTenant.do?templateId=${this.formData._id}`,
          'i/templateMarket/applyTemplateTenant.do?templateId=1340835581184723420', // 复制默认租户模板
          this.register,
          () => {
            this.registerShow = false;
            this.register = { exts: {} };
            this.count = 0;
            this.osg.alert('提交成功，请等待客服人员与您联系。');
          },
          {
            noload: true
          }
        );
      }
    },
    formatScene(item) {
      return this.osg.codelabel('scene', item);
    },
    formatTrade(item) {
      return this.osg.codelabel('trade', item);
    }
  }
};
</script>
<style scoped lang="scss">
.templates {
  .el-header {
    position: fixed;
    z-index: 1;
    width: 100vw;
    height: 60px !important;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 hsl(0deg 0% 70% / 10%);
    display: flex;
    align-items: center;
    .nav-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      padding: 0 1rem;
    }
    .logo {
      min-width: 200px;
      height: 70%;
      padding-left: 1rem;
      display: flex;
      align-items: center;
    }
    .title {
      flex: 1;
      text-align: center;
    }
  }
  .c-container {
    padding-top: 60px;
    height: 100vh;
    .el-aside {
      min-width: 200px;
      padding-left: 1rem;
      overflow-y: hidden;
      .home-search {
        display: flex;
        width: 200px;
        padding: 1rem 0;
        box-sizing: border-box;
        i {
          color: #fff;
          width: 39px;
          display: flex;
          align-items: center;
          background-color: hsla(0, 0%, 0%, 0.25);
          text-align: center;
          justify-content: center;
          border-radius: 3px;
          margin-right: 10px;
        }
        .el-input {
          width: 150px;
        }
      }
      .el-menu-vertical-demo:not(.el-menu--collapse) {
        height: calc(100vh - 92px - 2rem);
        overflow-x: hidden;
        overflow-y: auto;
        .el-menu-item {
          padding-left: 40px !important;
          height: 45px;
          line-height: 45px;
          border-radius: 3px;
        }
        .el-menu-item.is-active {
          background-color: #f2f2f2;
        }
        .el-menu-item:hover {
          background-color: #f2f2f2;
        }
      }
    }
    .el-container {
      .el-main {
        max-width: 1000px;
        margin: 0 auto;
        background-color: #fff;
        padding: 1rem 0.5rem !important;
        overflow-y: auto !important;
        .nav {
          display: flex;
          flex-direction: row;
          align-items: center;
          .el-icon-s-home {
            color: #fff;
            width: 50px;
            height: 32px;
            display: flex;
            align-items: center;
            background-color: hsla(0, 0%, 0%, 0.25);
            text-align: center;
            justify-content: center;
            border-radius: 3px;
            margin-right: 10px;
          }
          .el-button {
            border-radius: 0 5px 5px 0;
            border-left: none;
          }
        }
        > div {
          height: auto !important;
          .title {
            margin: 0 0 1rem;
            font-size: 17px;
          }
          .el-col {
            padding-left: 0.5rem !important;
            padding-right: 0.5rem !important;
          }
          .el-row {
            margin-bottom: 1rem;
          }
          .el-row-sec .card {
            height: 120px;
            margin-bottom: 1rem;
          }
          .card {
            height: 220px;
            border-radius: 6px;
            cursor: pointer;
            background-color: #2d7ff9;
            position: relative;
            .card-item {
              height: 100%;
              box-sizing: border-box;
              mix-blend-mode: multiply;
              opacity: 0.5;
            }
            h1 {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              padding: 1rem;
              box-sizing: border-box;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
            }
          }
          .card:hover {
            box-shadow: 0 0 0 5px hsl(0deg 0% 0% / 10%);
          }
          .all {
            .item {
              min-width: 100px;
              height: 260px;
              border-radius: 6px;
              overflow: hidden;
              box-shadow: 0 0 0 2px hsl(0deg 0% 0% / 5%);
              cursor: pointer;
              margin-bottom: 1rem;
              .img {
                height: 140px;
              }
              .img:hover {
                opacity: 0.85;
              }
              .info {
                height: 120px;
                padding: 1rem;
                box-sizing: border-box;
                h4 {
                  margin-bottom: 8px;
                }
                .content {
                  opacity: 0.5;
                  overflow: hidden;
                  position: relative;
                  display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;
                  box-sizing: border-box;
                  font-size: 14px;
                }
              }
              .info:hover {
                opacity: 0.85;
              }
            }
          }
        }
        .form {
          .banner {
            height: 200px;
            margin-bottom: 2rem;
            width: 100%;
            border-radius: 6px;
            box-shadow: 0 0 0 2px hsl(0deg 0% 0% / 5%);
          }
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .el-button {
              font-size: 18px;
              width: 120px;
              height: 45px;
            }
          }
          .tags {
            .tag {
              display: inline-block;
              margin: 0 10px 10px 0;
              padding: 3px 10px;
              box-sizing: border-box;
              border-radius: 4px;
              background-color: #f2f2f2;
              color: rgba(43, 52, 65, 0.6);
              font-size: 13px;
            }
          }
          .desc {
            margin: 1rem 0;
            margin-top: calc(1rem - 10px);
            font-size: 14px;
          }
          .content {
            box-shadow: 0 0 0 2px hsl(0deg 0% 0% / 5%);
            border-radius: 6px;
            padding: 1rem;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.templates .nav-search .el-input__inner {
  border-radius: 5px 0 0 5px;
}
#app .templates .register-dialog {
  width: 100vw;
  height: 100vh;
  max-width: 500px;
  margin: auto;
  padding: 0;
  .el-dialog {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    min-width: auto;
    margin: 0 !important;
    .el-dialog__body {
      padding: 1rem 1.5rem;
    }
    .el-input-group__append {
      cursor: pointer;
    }
    .submit {
      margin-top: 50px;
      .el-button {
        width: 100%;
        font-size: 16px;
      }
    }
  }
}
@media screen and (min-width: 768px) {
  #app .templates .register-dialog {
    max-height: 670px;
  }
}
@media screen and (max-width: 768px) {
  #app .templates .register-dialog {
    .el-dialog {
      border-radius: 0;
    }
  }
}
</style>
